import type { LinkedPlayerBuildsSettings } from '@webapp2/shared/model'
import { adminState } from '../state'
import { ensureById } from './admin-entity-service'

export function ensureLinkedPlayerBuildsSettings(ids: string[]) {
  return ensureById<LinkedPlayerBuildsSettings>(
    'LinkedPlayerBuildsSettings',
    adminState.linkedPlayerBuildsSettings,
    ids
  )
}
